import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

export default function initOfferingsSlider(selector = '.ks-offerings__swiper') {
  const sliders = document.querySelectorAll(selector);

  sliders.forEach((el) => {
    const root = el.closest('.ks-offerings__slider') || el.parentElement;
    const nextEl = root ? root.querySelector('.ks-offerings__nav-next') : null;
    const prevEl = root ? root.querySelector('.ks-offerings__nav-prev') : null;

    new Swiper(el, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: { nextEl, prevEl },
      roundLengths: true,
      watchOverflow: true,
      breakpoints: {
        992: { slidesPerView: 2 },
      },
    });
  });
}
